import React from "react";
import { Box, Grid, Slide, Typography, CardMedia } from "@mui/material";
import { SecondaryStyle } from "../fonts";
import SwipeableTextMobileStepper from "./MobileStepper";

import LB from "../assets/Page4LB.webp";
import RA from "../assets/Page4RA.webp";

import LCT from "../assets/Page4LCT.webp";

import Carousel1Image1 from "../assets/Page4LA1.webp";
import Carousel1Image2 from "../assets/Page4LA2.webp";
import Carousel1Image3 from "../assets/Page4LA3.webp";
import Carousel2Image1 from "../assets/Page4RD1.webp";
import Carousel2Image2 from "../assets/Page4RD2.webp";
import Carousel3Image1 from "../assets/Page4RBB1.webp";
import Carousel3Image2 from "../assets/Page4RBB3.webp";
import Carousel3Image3 from "../assets/Page4RBB3.webp";

//@ts-ignore
import LCB from "../assets/Page4LCB.mp4";
//@ts-ignore
import RBT from "../assets/Page4RBT.mp4";

const carousel1Images = [Carousel1Image1, Carousel1Image2, Carousel1Image3];
const carousel2Images = [Carousel2Image1, Carousel2Image2];
const carousel3Images = [Carousel3Image1, Carousel3Image2, Carousel3Image3];

const Page4 = (props) => {
  const { checked, isReverse } = props;

  return (
    <Slide
      direction={isReverse ? "right" : "left"}
      in={checked}
      timeout={{
        enter: 1750,
        exit: 1750,
      }}
    >
      <Box
        sx={{
          width: "100vw",
          height: { xs: "100%", sm: "100vh" },
          overflow: { xs: "auto", sm: "hidden" },
        }}
      >
        <Grid container sx={{ height: "100%" }} id="scrollTarget">
          {/* First Half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{
                height: "100%",
                borderTop: { xs: "1vh solid #fff", sm: "none" },
              }}
            >
              {/* LA/LD */}

              <Grid
                item
                xs={12}
                sx={{
                  maxHeight: "50vh",
                  borderBottom: ".5vh solid #fff",
                  height: {
                    xs: "36.5vh",
                    sm: "100%",
                  },
                  borderRight: {
                    xs: "1vh solid #fff",
                    sm: ".5vh solid #fff",
                  },
                  borderLeft: {
                    xs: "1vh solid #fff",
                    sm: "none",
                  },
                }}
              >
                <SwipeableTextMobileStepper images={carousel1Images} />
              </Grid>

              {/** */}
              <Grid item xs={12} sm={6}>
                <Grid container direction={"row"} sx={{ height: "100%" }}>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderTop: ".5vh solid #fff",
                      borderBottom: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },

                      height: {
                        xs: "94vh",
                        sm: "100%",
                      },
                      maxHeight: { xs: "100%", sm: "49.5vh" },
                    }}
                  >
                    <Box
                      sx={{
                        height: { xs: "46vh", sm: "24vh" },
                        borderRadius: { xs: "16px", sm: "0vh" },
                        backgroundImage: `url('${LCT}')`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        borderBottom: {
                          xs: ".5vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                      }}
                    />

                    <Box
                      sx={{
                        height: { xs: "46vh", sm: "25vh" },

                        borderRadius: { xs: "16px", sm: "0vh" },
                        borderTop: ".5vh solid #fff",
                      }}
                    >
                      <CardMedia
                        component={"video"}
                        sx={{
                          borderRadius: { xs: "16px", sm: "0vh" },
                          height: "100%",
                          objectFit: "cover",
                          objectPosition: "bottom",
                        }}
                        src={LCB}
                        autoPlay
                        muted
                        loop
                        playsInline
                      />
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      height: { xs: "46vh", sm: "100%" },
                      maxHeight: "50vh",
                      borderBottom: { xs: ".5vh solid #fff", sm: "none" },
                      borderTop: ".5vh solid #fff",

                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      backgroundImage: `url('${LB}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      borderRadius: { xs: "16px", sm: "0vh" },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* 2nd half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    maxHeight: { xs: "82vh", sm: "100%" },
                    borderTop: {
                      xs: ".5vh solid #fff",
                      sm: "none",
                    },
                  }}
                >
                  {/**RC */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      maxHeight: "50vh",
                      borderBottom: ".5vh solid #fff",
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },

                      borderRadius: { xs: "16px", sm: "0vh" },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      height: {
                        xs: "35.5vh",
                        sm: "50vh",
                      },
                    }}
                  >
                    <SwipeableTextMobileStepper
                      images={carousel2Images}
                      autoplay={false}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      maxHeight: "50vh",
                      borderBottom: ".5vh solid #fff",
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderTop: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      backgroundImage: `url('${RA}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      borderRadius: { xs: "16px", sm: "0vh" },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      height: {
                        xs: "45.5vh",
                        sm: "50vh",
                      },
                    }}
                  ></Grid>
                </Grid>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    borderTop: ".5vh solid #fff",
                  }}
                >
                  {/* RD */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      px: { xs: 1.5, md: 1.5, lg: 2, xl: 3 },
                      pb: { xs: 1.5 },
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        ...SecondaryStyle,

                        textAlign: { xs: "justify", sm: "left" },
                        "@media (orientation: landscape)": {
                          fontSize: { xs: "1vw", md: "1vw", lg: "0.95vw" },
                          lineHeight: {
                            xs: "1.5vw",
                            md: "1.5vw",
                            lg: "1.5vw",
                          },
                        },
                        "@media (orientation: portrait)": {
                          fontSize: { xs: "1.7vh", sm: "1vh" },
                          lineHeight: {
                            xs: "2vh",
                            sm: "1.5vh",
                            md: "1.5vh",
                            lg: "1.5vh",
                          },
                          paddingTop: {
                            xs: "1vh",
                            sm: "2vh",
                            md: "2vh",
                            lg: "2vh",
                          },
                        },
                      }}
                    >
                      The primary bedroom upstairs is a spacious retreat, filled
                      with natural light and thoughtfully designed for comfort
                      and style. The accompanying bathroom offers a touch of
                      luxury with a classic soaking tub and sleek finishes,
                      creating a serene environment for relaxation. Tucked away
                      is the washer and dryer, conveniently located in the
                      unfinished basement, which also provides ample storage
                      space and potential for further customization. This setup
                      offers a perfect balance of functionality and opportunity,
                      making it ideal for those who value both convenience and
                      the ability to personalize their living space.
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderBottom: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },

                      height: {
                        xs: "84vh",
                        sm: "100%",
                      },
                      maxHeight: { xs: "100%", sm: "50vh" },
                    }}
                  >
                    <Box
                      sx={{
                        height: { xs: "46vh", sm: "24vh" },
                        borderRadius: { xs: "16px", sm: "0vh" },

                        borderBottom: {
                          xs: ".5vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                      }}
                    >
                      <CardMedia
                        component={"video"}
                        sx={{
                          borderRadius: { xs: "16px", sm: "0vh" },
                          height: "100%",
                          objectFit: "cover",
                          objectPosition: "bottom",
                        }}
                        src={RBT}
                        autoPlay
                        muted
                        loop
                        playsInline
                      />
                    </Box>

                    <Box
                      sx={{
                        height: { xs: "36vh", sm: "25vh" },

                        borderRadius: { xs: "16px", sm: "0vh" },
                        borderTop: ".5vh solid #fff",
                      }}
                    >
                      <SwipeableTextMobileStepper
                        images={carousel3Images}
                        autoplay={false}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default Page4;
